import React from "react";
import ObjectUtils from "util/ObjectUtils";
import { Input } from "components/bootstrap";
import { Select, TimeUnitInput } from "components/common";
class AbuseChRansomAdapterFieldSet extends React.Component {
  constructor() {
    super(...arguments);
    this._update = (value, unit, enabled, name) => {
      const config = ObjectUtils.clone(this.props.config);
      config[name] = enabled ? value : 0;
      config[`${name}_unit`] = unit;
      this.props.updateConfig(config);
    };
    this.updateRefreshInterval = (value, unit, enabled) => {
      this._update(value, unit, enabled, "refresh_interval");
    };
    this._onBlocklistTypeSelect = (id) => {
      const config = ObjectUtils.clone(this.props.config);
      config.blocklist_type = id;
      this.props.updateConfig(config);
    };
  }
  render() {
    const { config } = this.props;
    const blocklistTypes = [
      { label: "Domain blocklist", value: "DOMAINS" },
      { label: "URL blocklist", value: "URLS" },
      { label: "IP blocklist", value: "IPS" }
    ];
    return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        label: "Blocklist type",
        id: "blocklist-type-selector",
        required: true,
        autoFocus: true,
        help: "Select the type of the abuse.ch ransomware blocklist",
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      },
      /* @__PURE__ */ React.createElement(
        Select,
        {
          placeholder: "Select the type of blocklist",
          clearable: false,
          options: blocklistTypes,
          onChange: this._onBlocklistTypeSelect,
          value: config.blocklist_type
        }
      )
    ), /* @__PURE__ */ React.createElement(
      TimeUnitInput,
      {
        label: "Refresh blocklist",
        help: "If enabled, the abuse.ch ransomware blocklist is refreshed when it changed.",
        update: this.updateRefreshInterval,
        value: config.refresh_interval,
        unit: config.refresh_interval_unit || "MINUTES",
        defaultEnabled: config.refresh_interval > 0,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ));
  }
}
export default AbuseChRansomAdapterFieldSet;
